module.exports = __webpack_public_path__ + "static/media/humanLogo.912c0969.svg";